import React from 'react';

import ReportDetail from './report_detail';
import { connect } from 'react-redux';
import { updateFinalReportForm, exportReport } from '../../store/actions/reports';
import { ExportType } from '../../shared/models/reportModels';

interface IProps {
    reportForm: any,
    reportDetail: any,
    isFetching: any,
    updateFinalReportForm: Function,
    exportReport: Function,
    isExportingReport: any,
}

const ReportViewer = (props: IProps) => {
    const { 
        reportForm, 
        isFetching, 
        reportDetail, 
        updateFinalReportForm, 
        exportReport,
        isExportingReport
    } = props;

    const handleChange = (e) => {
        reportForm.exportType = Number(e.target.value);
        updateFinalReportForm(reportForm);
    }
    
    const handleExport = async () => {
        await exportReport(reportForm);
    }

    return <div className='generated-report'>
        {
            isFetching && isFetching !== null && <div className='report-loader'>
                <div className='sk-chase'>
                    <div className='sk-chase-dot' />
                    <div className='sk-chase-dot' />
                    <div className='sk-chase-dot' />
                    <div className='sk-chase-dot' />
                    <div className='sk-chase-dot' />
                    <div className='sk-chase-dot' />
                </div>
            </div>
        }

        {
            reportDetail === null && isFetching === null && <h3 className='d-flex justify-content-center'> Please run report to view report </h3>
        }

        {
            reportDetail !== null && reportDetail.length > 0 && reportDetail !== null && !isFetching && <div>
                <div className='d-flex justify-content-end mb-5'>
                    <div className='col-xl-4'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <select
                                    className="form-control selectpicker btn btn-light"
                                    name="reportEnum"
                                    value={ reportForm.exportType }
                                    onChange={(e: any) => handleChange(e)}
                                >
                                    <option key={ExportType.CSV} value={ExportType.CSV}>{ExportType[ExportType.CSV]}</option>
                                    <option key={ExportType.Excel} value={ExportType.Excel}>{ExportType[ExportType.Excel]}</option>
                                </select>
                            </div>

                            <div className='col-md-6'>
                                <button
                                    disabled={isExportingReport}
                                    type='button' 
                                    onClick={() => handleExport()} 
                                    className='btn btn-secondary ex-report w-100'>
                                        { !isExportingReport ? 'Export Report': 'Exporting...' }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <ReportDetail 
                    reportForm={reportForm} 
                    reportDetail={reportDetail}
                />
            </div>
        }

        {
            reportDetail !== null && !isFetching && !reportDetail.length && <div className='d-flex justify-content-center'>
                <h3>Data not available!</h3>
            </div>
        }
    </div>
}

const mapStateToProps = ({report}) => ({
    isExportingReport: report.isExportingReport
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        exportReport: (params: any) => dispatch(exportReport(params)),
        updateFinalReportForm: (params: any) => dispatch(updateFinalReportForm(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportViewer);

